const factory = require('./lib/url-assembler-factory');
module.exports = factory();
exports.default = module.exports;
